import { RiskCard } from '../types';

interface RiskCardsProps {
  risks: RiskCard[];
}

export default function RiskCards({ risks }: RiskCardsProps) {
  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-50 border border-red-200 rounded-full mb-4">
            <i className="ri-alert-line text-red-500"></i>
            <span className="text-sm font-medium text-red-600">你会遇到的坑</span>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {risks.map((risk, idx) => (
            <div
              key={idx}
              className="bg-white border border-red-100 rounded-2xl p-6 hover:shadow-lg transition-all"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-red-50 text-red-500 mb-4">
                <i className={`${risk.icon} text-xl`}></i>
              </div>
              <h4 className="text-base font-bold text-gray-900 mb-2">{risk.title}</h4>
              <p className="text-sm text-gray-600 leading-relaxed">{risk.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}